import React, {useRef, useState, useEffect} from 'react';
import {View, Text, FlatList, Dimensions} from 'react-native';
import styles from './Slider.style';
import LottieView from '../../../../../../imports/Lottie';
import SVG from '../../../svglearn';
import EmptyBox from '../../../../../../components/empty-box/EmptyBox.component';

const SlideItems = ({data, id}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const slideWidth = Dimensions.get('window').width;
  const height = Dimensions.get('window').height;
  const slideMargin = 2;
  const aspectRatio = 1.2;

  const flatListRef = useRef(null);

  // برای اطمینان از اینکه صفحه از ابتدا شروع می‌کند
  useEffect(() => {
    if (flatListRef.current) {
      flatListRef.current.scrollToIndex({index: 0, animated: false});
    }
  }, []);

  const renderItem = ({item, index}) => (
    <View style={{width: slideWidth - 35, marginRight: slideMargin}}>
      {/* کارت اصلی */}
      <View
        style={[
          styles.card,
          {width: '95%', height: (slideWidth - 35) / aspectRatio},
        ]}>
        {item.img === '' ? (
          <LottieView
            autoPlay
            loop
            source={require('../../../../../../assets/animations/zeerozin.json')}
            style={styles.loading}
          />
        ) : (
          <SVG name={item.img} width="100%" height="100%" />
        )}
      </View>

      {/* محتوا */}
      <View style={styles.Content}>
        <Text style={styles.text}>{item.text}</Text>

        {/* IconList */}
        <View style={styles.box}>
          {item.IconList?.length !== 0 &&
            item.IconList.map(icon => (
              <View style={styles.iconbox} key={icon.id}>
                <Text style={styles.text_icon}>{icon.name}</Text>
                <SVG name={icon.image} width={24} height={24} />
              </View>
            ))}
        </View>

        {/* Decription */}
        <View style={styles.boxDecription}>
          {item.Decription?.length !== 0 &&
            item.Decription.map(desc => (
              <View style={styles.textbox} key={desc.id}>
                <Text style={styles.text_icon}>{desc.name}</Text>
                <SVG name={desc.image} width={16} height={16} />
              </View>
            ))}
        </View>

        {/* Zindesc */}
        <View style={styles.boxzin}>
          {item.zindesc?.length !== 0 &&
            item.zindesc.map(zin => (
              <View style={styles.zintextbox} key={zin.id}>
                <Text style={styles.text_icon}>{zin.name}</Text>
              </View>
            ))}
        </View>
        {console.log(
          id !== undefined ? height / 2 - 350 : height / 2 - 330,
          'asasasasas',
          id,
          'id',
        )}
        <EmptyBox
          height={id !== undefined ? height / 2 - 350 : height / 2 - 330}
        />
      </View>
    </View>
  );

  return (
    <View style={{marginTop: 20}}>
      {/* Dots */}
      <View style={styles.dotsWrapperTop}>
        {data.map((_, index) => (
          <View
            key={index.toString()}
            style={[styles.dot, activeIndex === index && styles.activeDot]}
          />
        ))}
      </View>

      <FlatList
        ref={flatListRef} // اضافه کردن ref برای FlatList
        data={data}
        horizontal
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        renderItem={renderItem}
        keyExtractor={(item, index) => index.toString()}
        onScroll={e => {
          const contentOffsetX = e.nativeEvent.contentOffset.x;
          const slideWidthWithMargin = slideWidth - 35 + slideMargin;
          const index = Math.round(contentOffsetX / slideWidthWithMargin);
          setActiveIndex(index);
        }}
        scrollEventThrottle={16}
        removeClippedSubviews={false}
        initialNumToRender={1}
        windowSize={3}
        initialScrollIndex={0} // اطمینان از شروع از ایتم اول
        snapToInterval={slideWidth - 35 + slideMargin} // استفاده از snapToInterval
        // onContentSizeChange={() => {
        //   if (flatListRef.current) {
        //     flatListRef.current.scrollToIndex({index: 0, animated: false});
        //   }
        // }}
      />
    </View>
  );
};

export default SlideItems;
